'use client'

import { useAttachments } from '../../../../store'
import { memo } from 'react'
import { Attachments } from '../../attachments'

export const InputAttachments = memo(() => {
  const attachments = useAttachments()
  return <Attachments attachments={attachments} canRemove={true} />
})
InputAttachments.displayName = 'InputAttachments'
